// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blue-button_button__OE5qn{
  width:fit-content;
  height: fit-content;
  padding: 8px 14px;
  margin: 30px;
  margin-top: 50px;
  background: #004DFF;
  border-radius: 50px;
  font-family: "FreckleFace", serif;
  font-size: 60px;
  font-weight: 400;
  line-height: 70px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  padding: 0 30px;
  color: white;
  box-shadow: 0px 2px 5px 0px #F5F5F5;
 cursor: pointer;
}

.blue-button_button__OE5qn:disabled,
.blue-button_button__OE5qn:disabled:hover,
.blue-button_button__OE5qn:disabled:active{
  background: #004DFFB2;
  cursor: auto;
}

/* Style for the arrow icon */
.blue-button_icon__tB840 {
  font-size: 20px; /* Adjust the size of the arrow */
  color: white; /* Match the color */
  position: relative;
}
.blue-button_spinner__eHlUE {
  animation: blue-button_spin__INHgP 1s linear infinite; /* Rotates the spinner */
}

/* Keyframes for rotation */
@keyframes blue-button_spin__INHgP {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/UI/common/Buttons/blue-button.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kCAAkC;EAClC,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,mCAAmC;CACpC,eAAe;AAChB;;AAEA;;;EAGE,qBAAqB;EACrB,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,eAAe,EAAE,iCAAiC;EAClD,YAAY,EAAE,oBAAoB;EAClC,kBAAkB;AACpB;AACA;EACE,qDAAkC,EAAE,wBAAwB;AAC9D;;AAEA,2BAA2B;AAC3B;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".button{\n  width:fit-content;\n  height: fit-content;\n  padding: 8px 14px;\n  margin: 30px;\n  margin-top: 50px;\n  background: #004DFF;\n  border-radius: 50px;\n  font-family: \"FreckleFace\", serif;\n  font-size: 60px;\n  font-weight: 400;\n  line-height: 70px;\n  text-align: center;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n  padding: 0 30px;\n  color: white;\n  box-shadow: 0px 2px 5px 0px #F5F5F5;\n cursor: pointer;\n}\n\n.button:disabled,\n.button:disabled:hover,\n.button:disabled:active{\n  background: #004DFFB2;\n  cursor: auto;\n}\n\n/* Style for the arrow icon */\n.icon {\n  font-size: 20px; /* Adjust the size of the arrow */\n  color: white; /* Match the color */\n  position: relative;\n}\n.spinner {\n  animation: spin 1s linear infinite; /* Rotates the spinner */\n}\n\n/* Keyframes for rotation */\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `blue-button_button__OE5qn`,
	"icon": `blue-button_icon__tB840`,
	"spinner": `blue-button_spinner__eHlUE`,
	"spin": `blue-button_spin__INHgP`
};
export default ___CSS_LOADER_EXPORT___;
